/**
 * Philips Device Connector — sidebar icon copy and styling from connection status.
 */

/** @typedef {import("./philipsPdcConnectionState").PhilipsPdcState} PhilipsPdcState */

const ICON_BUTTON_BASE_CLASS =
  "relative flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-gray-800 sm:h-9 sm:w-9";

const ICON_BUTTON_STATUS_CLASS = {
  device_ready:
    "bg-green dark:bg-green-dark text-gray-900 shadow-md ring-2 ring-green-dark/40 dark:ring-green/50 ring-offset-2 ring-offset-white dark:ring-offset-gray-800 hover:bg-green-dark dark:hover:bg-green",
  connected:
    "bg-sky-100 text-sky-900 ring-2 ring-sky-300/70 hover:bg-sky-200 dark:bg-sky-950/50 dark:text-sky-100 dark:ring-sky-500/40 dark:hover:bg-sky-950/70",
  extension_only:
    "text-amber-900 dark:text-amber-200 bg-amber-100 dark:bg-amber-900/40 ring-2 ring-amber-400/50 hover:bg-amber-200 dark:hover:bg-amber-900/60",
  default:
    "bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600",
};

/**
 * @param {import("i18next").TFunction} t
 * @param {PhilipsPdcState} state
 * @returns {string}
 */
export function getPhilipsPdcIconTitle(t, state) {
  if (state.status === "device_ready") {
    return t("philipsPdcIconTitleDeviceReady", {
      device: state.deviceTypeName || "SpeechMike",
    });
  }
  if (state.status === "connected") {
    return t("philipsPdcIconTitleReady");
  }
  if (state.status === "extension_only") {
    return t("philipsPdcIconTitleExtensionOnly");
  }
  return t("philipsPdcHelpTitle");
}

/**
 * @param {PhilipsPdcState["status"]} status
 * @returns {string}
 */
export function getPhilipsPdcIconButtonClassName(status) {
  const statusClass =
    status === "device_ready"
      ? ICON_BUTTON_STATUS_CLASS.device_ready
      : status === "connected"
        ? ICON_BUTTON_STATUS_CLASS.connected
        : status === "extension_only"
          ? ICON_BUTTON_STATUS_CLASS.extension_only
          : ICON_BUTTON_STATUS_CLASS.default;

  return `${ICON_BUTTON_BASE_CLASS} ${statusClass}`;
}

/**
 * @param {PhilipsPdcState["status"]} status
 * @returns {boolean}
 */
export function isPhilipsPdcSidebarIconVisible(status) {
  return status !== "pending";
}

/**
 * @param {PhilipsPdcState["status"]} status
 * @returns {boolean}
 */
export function isPhilipsPdcDeviceReadyIndicatorVisible(status) {
  return status === "device_ready";
}
